<div>
  <ng-container *ngIf="loading">
    <div class="spots">
      <div class="spot" *ngFor="let spot of spots; let i = index">
        <div class="spot__inner" (click)="openSpot(i)" [ngClass]="spotColors[i]">
          <div class="item pie">
            <app-pie-chart-2 *ngIf="spot?.realisationPercent != 0 && spot?.realisationPercent != 100"
              [centerText]="spot?.realisationPercent"></app-pie-chart-2>
          </div>
          <div class="item number w-150">
            <div class="title" *ngIf="spot.number !== null">Пятно {{spot.number}}</div>
            <div class="title" *ngIf="spot.number === null">Пятно {{spot.number}}</div>
          </div>
          <div class="item w-150">
            <div class="title" *ngIf="spot.apartment_number !== null">Всего квартир
              {{spot.apartment_number | numberWithSpaces}}</div>
            <div class="title" *ngIf="spot.apartment_number === null">Всего квартир
              {{spot.apartment_number | numberWithSpaces}}</div>
          </div>
          <div class="item w-150">
            <div class="title" *ngIf="spot.residueFlatCount !== null">Остаток квартир
              {{spot.residueFlatCount | numberWithSpaces}}</div>
            <div class="title" *ngIf="spot.residueFlatCount === null">Остаток квартир -</div>
          </div>
          <div class="item f-1">
            <div class="title" *ngIf="spot.totalFlatArea !== null">Общая площадь, кв.м.
              {{spot.totalFlatArea | numberWithSpaces}}</div>
            <div class="title" *ngIf="spot.totalFlatArea === null">Общая площадь, кв.м. - </div>
          </div>
          <div class="item f-1">
            <div class="title">Общая стоимость, в тг. {{calculate(object.investments.own_investments,
              object.investments.bd_investments) | numberWithSpaces}}</div>
          </div>
        </div>
         <div class="spot-info" *ngIf="spot.isOpen">
          <div class="spot-info-in">
            <div class="spot-1">
              <div class="percent">{{spot.completionPercent ? spot.completionPercent : '-'}}%</div>
              <div class="gpr">ГПР</div>
            </div>
            <div class="spot-2" *ngFor="let stage of spot.stages;let j = index">
              <div class="etaps">
                <div class="spot_info wTooltip">
                  <div class="tooltip">{{getTooltip(stage.number)}}</div>
                  {{stage.number}} этап
                </div>
              </div>
              <div class="percent-date spot-all" (click)="openStageCalendar(spot, stage)">
                <ng-container *ngIf="stage.complete == 0">-</ng-container>
                <ng-container *ngIf="stage.complete != 0"> {{stage.complete}}%</ng-container>
              </div>
              <div class="start-end-date spot-all" (click)="openPeriodModal(spot, stage)">
                <ng-container *ngIf="getDate(stage.start_date) == '-' && getDate(stage.end_date) == '-'">
                  <div>-</div>
                </ng-container>
                <ng-container *ngIf="getDate(stage.start_date) != '-' && getDate(stage.end_date) != '-'">
                  <div>{{getDate(stage.start_date)}}</div>
                  <div>{{getDate(stage.end_date)}}</div>
                </ng-container>
              </div>
            </div>
            <div class="circle">
              <div class="btn btn-confirm btn-circle" (click)="openLineChart(spot); $event.stopPropagation()">
                <span class="icon-chart"></span>
              </div>
              <div class="btn btn-confirm btn-circle" (click)="clickProblem()">
                <span class="icon-edit"></span>
              </div>
            </div>

          </div>
          <div class="explut">
            <div class="actDoc" *ngIf="spot.docs?.length === 0">
              <!-- <div class="upload">Акт приемки ввода в эксплуатацию</div> -->
              <div class="attach-icon act">
                <!-- <img src="assets/svg-icons/attach.svg"> -->
                <div class="btn btn-act" [ngClass]="spot.stages[6].complete !== 100?'gray':''">Акт приёмки объекта в
                  эксплуатацию</div>
                <input type="file" accept="application/pdf" *ngIf="spot.stages[6].complete === 100"
                  (change)="uploadSpotActDocument($event.target.files, 5, spot.id, i)">
              </div>
            </div>
            <div class="actDoc">
              <div class="actDocName" *ngIf="spot.docs?.length > 0">
                <a [attr.href]="">{{spot.docs[0].fileName}}</a>
              </div>
              <div *ngIf="spot.docs?.length > 0">
                <span class="icon-delete" (click)="deleteActDocument(spot.docs[0].dbFileID, spot.docs, spot)"></span>
              </div>
            </div>
            <div class="canlendarAct">
              <button *ngIf="spot.calendarActVis" [disabled]="!disCalendar" [ngClass]="!disCalendar? 'disCalendar': ''"
                class="icon-calendar" (click)="actCalendar = true"></button>
            </div>


            <!-- START DATE -->
            <app-modal-window *ngIf="actCalendar" [title]="'Календарь'" [visible]="actCalendar"
              (close)="actCalendar = $event" [width]="1300" [scrollbar]="false">
              <app-calendar (outputDate)="spotDocDate = $event; actCalendar = false; sendActDate(spot)"
                [inputDate]="object.development_start_date"></app-calendar>
            </app-modal-window>
          </div>
          <div class="spot-form" *ngIf="spotForm">
            <app-spot-form-editor [spotObject]="spot" [livingComplexID]="livingComplexID"
              [wallMaterialTypes_]="wallMaterialTypes" [buildingRoomTypes]="buildingRoomTypes"
              [buildingClasses]="buildingClasses"> </app-spot-form-editor>
          </div>
          <div class="full-version">
            <div class="items">
              <ng-container *ngIf="foundSpot?.type === 1">
                <div class="left">
                  <img class="key" src="./assets/svg-icons/closedkey.svg">
                  <div class="title">Полная версия</div>
                </div>
                <div class="text"> {{foundSpot?.message}} </div>
              </ng-container>
              <ng-container *ngIf="foundSpot?.type !==1 ">
                <div class="left">
                  <img class="key" src="./assets/svg-icons/openkey.svg">
                  <div class="title">Полная версия</div>
                </div>
                <div class="text"> {{foundSpot?.message}} </div>
              </ng-container>
            </div>
          </div>
          <div class="full-version-info" *ngIf="foundSpot?.type !== 1">
            <div class="construction-info" *ngIf="loading">
              <div class="type-fundament">
                <div class="info-title">
                  <div class="title" *ngFor="let titles of infoTitle">
                    <div>{{titles.title}}</div>
                  </div>
                </div>
                <ul class="main-info">
                  <ng-template #recursiveList let-selectedFlorInfo>
                    <li class="info-in" *ngFor="let item of selectedFlorInfo;let x = index">
                      <div [ngClass]="item.unitID !== 0 ?'child':''">
                        <div class="title" [ngClass]="item.isReadyFlag == true || item.unitID !==0 ?'stagesStatus':''"
                          (click)="openTree(item)">
                          <div class="show-hide" *ngIf="item.unitID == 0 && item.isReadyFlag == false">
                            <div *ngIf="item.showChild==true">-</div>
                            <div *ngIf="item.showChild==false || !item.showChild">+</div>
                          </div>
                          <div class="item" [ngClass]="item.unitID !== 0 ?'child':''">
                            <div class="stage" *ngIf="item.parentID == null">{{1+x}} Этап</div> {{item.title}}
                          </div>
                          <div class="item" *ngIf="item.unitID !== 0">{{item.prodIndicatorTitle}} {{item.unitTitle}}
                          </div>
                          <div class="item" *ngIf="item.unitID !== 0">{{item.completionPercent}}%</div>
                          <div class="item" *ngIf="item.unitID !== 0">{{item.factValue}}</div>
                          <div class="item" *ngIf="item.unitID !== 0">
                            <div class="plan">
                              <div class="plan-item" *ngIf="!item.planValueEdit" (click)="openPlanInput(x,item)">
                                <ng-container *ngIf="item.planValue != 0">{{item.planValue}}</ng-container>
                                <ng-container *ngIf="item.planValue == null">-</ng-container>
                              </div>
                              <div class="input-item">
                                <input class="form-control" focus="true" *ngIf="item.planValueEdit"
                                  [(ngModel)]="item.planValue" type="number" (keydown)="setFieldValue(x,item, $event)"
                                  placeholder="-" />
                              </div>
                            </div>
                            <!-- <div (click)="openPlanInput(x,item)">
                              <div class="plan" *ngIf="!item.planValueEdit">
                                <ng-container *ngIf="item.planValue != 0">{{item.planValue}}</ng-container>
                                <ng-container *ngIf="item.planValue == null">-</ng-container>
                              </div>
                            </div>

                            <div class="plan" *ngIf="item.planValueEdit">
                              <input class="form-control" focus="true" [(ngModel)]="item.planValue" type="number" (keydown)="openPlanInput(x,item,'item.planValueEdit', $event)"
                                placeholder="-" />
                            </div> -->
                          </div>
                          <div class="item" *ngIf="item.unitID !== 0">
                            <button class="btn-calendar"
                              (click)="startCalendarOpen(item)">{{getDate(item.planFromDate)}}</button>
                          </div>
                          <div class="item" *ngIf="item.unitID !== 0">
                            <button class="btn-calendar"
                              (click)="endCalendarOpen(item)">{{getDate(item.planToDate)}}</button>
                          </div>
                          <div class="item" *ngIf="item.isReadyFlag == false && item.unitID !== 0">
                            <button class="accept-btn" (click)="sendInfo(item)"
                              [disabled]="item.planValue == null && item.planFromDate == null && item.planToDate == null"
                              [ngClass]="acceptInfo(item)">Подтвердить</button>
                          </div>
                          <div class="item" *ngIf="item.isReadyFlag == true">
                            <div *ngIf="item.stageIsReady == false">Не завершён</div>
                            <div *ngIf="item.stageIsReady == true">Завершён</div>
                          </div>
                        </div>
                      </div>
                      <ul *ngIf="item.categories.length > 0 && item.showChild" class="margin">
                        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.categories }">
                        </ng-container>
                      </ul>
                    </li>
                  </ng-template>
                  <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: selectedFlorInfo }">
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="addSpot()">Добавить
        пятно</div>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading">
    <div class="loading"></div>
  </ng-container>

  <ng-container *ngIf="activeSpot && activeStage && periodModal">
    <app-modal-window [title]="'Календарь ГПР'" [visible]="periodModal" (close)="periodModal = $event" [width]="1300"
      [scrollbar]="false">
      <app-calendar [calendarType]="'pickPeriod'" [inputStartDate]="activeStage.start_date"
        [inputEndDate]="activeStage.end_date" (outputStartDate)="outputPeriodModal($event, true)"
        (outputEndDate)="outputPeriodModal($event, false)"></app-calendar>
    </app-modal-window>
  </ng-container>

  <app-modal-window *ngIf="startCalendarModal" [title]="'Календарь'" [visible]="startCalendarModal"
    (close)="startCalendarModal = $event" [width]="1300" [scrollbar]="false">
    <app-calendar
      (outputDate)="currentStartCalendar.planFromDate = $event; startCalendarModal = false; currentStartCalendar = null"
      [inputDate]="currentStartCalendar.planFromDate"></app-calendar>
  </app-modal-window>

  <app-modal-window *ngIf="endCalendarModal" [title]="'Календарь'" [visible]="endCalendarModal"
    (close)="endCalendarModal = $event" [width]="1300" [scrollbar]="false">
    <app-calendar
      (outputDate)="currentStartCalendar.planToDate = $event; endCalendarModal = false; currentStartCalendar = null"
      [inputDate]="currentStartCalendar.planToDate"></app-calendar>
  </app-modal-window>

  <ng-container *ngIf="stageLoading">
    <app-modal-window [title]="calendarTitle" [visible]="calendarModal" (close)="calendarModal = $event" [width]="1300"
      [scrollbar]="false">
      <app-calendar [buildingId]="selectedSpotId" [stage]="activeStage" [use]="'percent'"
        [inputCompleteDate]="completeDates" [calendarType]="'setValueInDate'"
        (outputCompleteDate)="saveValues($event); calendarModal = false"></app-calendar>
    </app-modal-window>
  </ng-container>

  <!-- Graphic container -->
  <ng-container *ngIf="graphicModal">
    <app-modal-window [title]="'График для Пятна №'+selectedSpotEx?.number" [visible]="graphicModal"
      (close)="graphicModal = $event" [height]="420" [width]="940" [scrollbar]="true">
      <app-line-chart-construction [spot]="selectedSpotEx"></app-line-chart-construction>
    </app-modal-window>
  </ng-container>


</div>

<app-modal-window [title]="'Проблемные вопросы'" [visible]="problem" (close)="problem = $event"
  [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <textarea name="problemsQuestion" [(ngModel)]="problemsQuestion"></textarea>
    </div>
    <div class="btns">
        <div class="btn-accept"
          (click)="confirmProblem()">
          Применить</div>
        <div class="btn-decline" (click)="cancelProblem()">
          Отменить</div>
        <div class="btn-danger"
          (click)="deleteProblem()">
          Удалить</div>
      </div>
    </div>
</app-modal-window>
